import React from "react";
import { Modal as AntModal, Button } from "antd";
import { useTranslation } from "react-i18next";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  onConfirm,
  confirmText = "Confirm",
  showConfirm = true,
  confirmDisabled = false,
  confirmColor,
}) => {
  const { t } = useTranslation();

  const footer = showConfirm
    ? [
        <Button key="cancel" onClick={onClose}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="confirm"
          type={confirmColor === "danger" ? "primary" : "primary"}
          danger={confirmColor === "danger"}
          loading={confirmDisabled}
          disabled={confirmDisabled}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>,
      ]
    : null;

  return (
    <AntModal
      open={isOpen}
      title={title}
      onCancel={onClose}
      footer={footer}
      maskClosable={false}
    >
      {children}
    </AntModal>
  );
};

export default Modal;
